import styles from "./styles.module.scss";

const FiltersButton = ({ label, isActive, onClick }) => {
  return (
    <div
      type="button"
      className={`${styles.filtersBtn} ${isActive ? styles.active : ""}`}
      onClick={onClick}
    >
      {label}
    </div>
  );
};

export default FiltersButton;
